
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';

	@Observer
	@Component({
		components: { PrescriptionItemWrapper }
	})
	export default class PrescriptionItemExtendedSelectLR extends PrescriptionItem {
		@PropSync('inputSelect', { required: true, default: '' }) inputSelectValue!: string;
		@PropSync('inputSelectLeftFirst', { required: true, default: '' }) inputSelectValueLFirst!: string;
		@PropSync('inputSelectLeftSecond', { required: false, default: '' }) inputSelectValueLSecond!: string;
		@PropSync('inputSelectLeftThird', { required: false, default: '' }) inputSelectValueLThird!: string;
		@PropSync('inputSelectRightFirst', { required: true, default: '' }) inputSelectValueRFirst!: string;
		@PropSync('inputSelectRightSecond', { required: false, default: '' }) inputSelectValueRSecond!: string;
		@PropSync('inputSelectRightThird', { required: false, default: '' }) inputSelectValueRThird!: string;
		@Prop({ required: true }) selectValues!: {};
		@Prop({ required: true }) LR!: { firstValue: {}; secondValue?: {}; thirdValue?: {} };
		@Prop({ required: true }) extended!: boolean;
	}
